export function selectUnion<K extends string, U extends { [key in K]: string }, T extends U[K]>(key: K, obj: U, type: T) {
  return (obj[key] === type ? obj : null) as Extract<U, { [key in K]: T }> | null
}
export function selectType<U extends { type: string }, T extends U['type']>(obj: U, type: T) {
  return (obj.type === type ? obj : null) as Extract<U, { type: T }> | null
}
export function selectMode<U extends { mode: string }, T extends U['mode']>(obj: U, mode: T) {
  return (obj.mode === mode ? obj : null) as Extract<U, { mode: T }> | null
}
